(ns quuppa.qsm.dashboard.view
  (:require [clojure.string :as str]
            [quuppa.components :as c]
            [quuppa.date-time.core :as date-time]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.not-found :as not-found]
            [quuppa.qsm.permissions :as permissions]
            [quuppa.qsm.projects.events :as pe]
            [quuppa.ui.layout :as layout]
            [quuppa.utils :as utils]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [quuppa.qsm.ui-state.subs :as state-subs]
            [goog.string :as gstring]
            [quuppa.qsm.dashboard.subs :as dashboard-subs]
            [quuppa.qsm.dashboard.events]))

(defn qsm-logs-table []
  (let [selected-files @(rf/subscribe [::dashboard-subs/selected-files])]
    (if (not (some? selected-files))
      [:h2 "loading ..."]
      [:<>
       [layout/view-header
        {:title "Logs"
         :actions [:div.d-flex.flex-row
                   [:a
                    {:class (str "btn btn-primary"
                                 (when (not (seq selected-files))
                                   " disabled"))
                     :download true
                     :href (gstring/format "/qsm-log-archive?selected-files=%s"
                                           (str/join "," selected-files))
                     :on-click #(rf/dispatch [:qsm/clear-selected-logs])}
                    "Download selected"]
                   [:button.btn.btn-primary.ml-4
                    {:disabled (not (seq selected-files))
                     :on-click (fn [_]
                                 (when (js/confirm "Delete selected files?")
                                   (rf/dispatch [:qsm/req-delete-logs {:file-names selected-files}])))}
                    "Delete selected"]]}]
       [:table.table.table-bordered.w-100.table-hover
        [:thead
         [:tr
          [:th "Name"]
          [:th "Date"]
          [:th "Size"]
          [:th "Level"]
          [:th]]]
        [:tbody
         (doall
           (for [{file-name :name :keys [last-modified max-level size]} @(rf/subscribe [::dashboard-subs/qsm-logs])]
             [:tr
              {:key file-name}
              [:td file-name]
              [:td (date-time/format-instant last-modified)]
              [:td (utils/format-bytes-for-log-table size)]
              [:td max-level]
              [:td [:input
                    {:type "checkbox"
                     :checked (contains? selected-files file-name)
                     :on-change (fn [_]
                                  (rf/dispatch [:select-log-file file-name]))}]]]))]]])))

(defn select-tab [tab] (rfe/href :dashboard-tab tab))

(defn available-projects [projects sites]
  [:div
   [:h2 "Available projects - " (count projects)]
   [:table.table.table-striped.table-bordered
    [:thead
     [:tr.bg-dark.text-white
      [:th "Project name"]
      [:th "Number of sites"]]]
    [:tbody
     (for [project projects]
       ^{:key (:id project)}
       [:tr
        [:td (:name project)]
        [:td (count sites)]])]]])

(defn available-sites [sites]
  [:div
   [:h2.mt-3 "Available sites - " (count sites)]
   [:div.grid
    (if (seq sites)
      (for [site sites]
        ^{:key (:id site)}
        [:div.card.project-site.g-col-12.g-col-sm-6.g-col-lg-4
         [:div.card-body.align-items-center
          [:h4.card-title.text-truncate
           [:a.text-decoration-none.text-dark.stretched-link
            {:href (rfe/href :site {:project-id (:project-id site)
                                    :site-id (:id site)})
             :data-test-id (str "site-card-link-title-" (:name site))}
            (:name site)]]
          [:h5.card-subtitle
           (str "Sites: " (count sites))]]])
      [:div.alert.alert-info "No projects yet"])]])

(defn dashboard []
  (let [{:keys [dashboard-tab]} @(rf/subscribe [:nav/match :parameters :path])
        selected-tab (or dashboard-tab :available-projects)
        {projects :result error :error} @(q/subscribe pe/projects-query {})
        projects (some->> projects not-empty (sort-by (comp str/lower-case :name)))
        sites nil
        sidebar @(rf/subscribe [::state-subs/ui-state :projects :sidebar])
        dashboard-tabs [{:label "Available projects"
                         :id    :available-projects}
                        {:label "Available sites"
                         :id    :available-sites}
                        {:label "Logs"
                         :id    :logs}]]

    [layout/section
     (if (permissions/has-manage-permission?)
       [layout/view-content
        {:sidebar-open (:type sidebar)}

        [layout/section-header
         {:title [:h1.mb-0
                  [:span "Dashboard"]]}]
        (when error
          [c/error-alert error])

        [:div.d-flex.flex-grow-1.flex-column
         [:ul.mt-2.nav.nav-tabs.d-flex.flex-shrink-0
          (for [{:keys [id label]} dashboard-tabs]
            [:li.nav-item
             {:key id}
             [:a.nav-link
              {:href (select-tab {:dashboard-tab id})
               :class (when (= selected-tab id)
                        "active")}
              label]])]

         [:div.mt-3
          (case selected-tab
            :available-projects [available-projects projects sites]
            :available-sites [available-sites sites]
            :logs [qsm-logs-table])]]]
       [not-found/not-found-view {:text "View not found"}])]))

(def dashboard-controller
  {:id :dashboard
   :identity nil
   :start (fn []
            (rf/dispatch [:qsm/req-list-logs]))
   :stop (fn [])})
